
// import React from 'react';
// import {  ShareIcon, } from '@heroicons/react/24/outline';

// const DiscoveryZone = () => {
//   const exploreItems = [
//     { title: 'Play "Math Monsters" Game!', desc: 'Practice addition and subtraction.', emoji: '🎮', color: 'text-indigo-600', bg: 'bg-indigo-100' },
//     { title: 'New Story: "The Brave Little Robot"', desc: 'A tale about courage and friendship.', emoji: '📚', color: 'text-orange-600', bg: 'bg-orange-100' },
//     { title: 'Creative Corner: Draw a Fantasy Creature', desc: 'Unleash your imagination!', emoji: '🎨', color: 'text-emerald-600', bg: 'bg-emerald-100' },
//   ];

//     const videos = [
//     {
//       id: 'Mo-X9t06rjk', // Placeholder YouTube video ID
//       title: 'Never Gonna Give You Up',
//       description: 'The classic Rick Astley hit!'
//     },
//     {
//       id: 'Mo-X9t06rjk', // Another placeholder ID
//       title: 'Lofi Hip Hop Radio',
//       description: 'Relax and study with this chill lofi stream.'
//     },
//     {
//       id: 'Mo-X9t06rjk', // Yet another placeholder ID
//       title: 'Amazing Nature Scenery',
//       description: 'Beautiful landscapes to soothe your mind.'
//     },
//     {
//       id: 'Mo-X9t06rjk', // And one more
//       title: 'Funny Cats Compilation',
//       description: 'A compilation of hilarious cat moments.'
//     },
//   ];

//   return (
//     <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-pink-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
//       <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
//         <ShareIcon className="w-8 h-8 mr-3 text-pink-600" />
//         Discovery Zone
//       </h2>
//       <p className="text-lg text-gray-700 mb-4">New adventures await! Explore and learn something new.</p>
//       <h3 className="text-xl font-semibold text-gray-900 mb-3">Explore More!</h3>
//       <div className="space-y-4">
//         {exploreItems.map((item, index) => (
//           <div
//             key={index}
//             className={`p-4 rounded-xl ${item.bg} flex items-center space-x-3 shadow-sm hover:shadow-lg transition-all duration-200 hover:scale-105`}
//           >
//             <div className={`w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl border-2 border-${item.color.split('-')[1]}-600`}>
//               {item.emoji}
//             </div>
//             <div>
//               <p className={`font-semibold ${item.color}`}>{item.title}</p>
//               <p className="text-sm text-gray-700">{item.desc}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Featured Video: Fun & Learning!</h3>
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         {videos.map((video) => (
//           <div
//             key={video.id}
//             className="p-4 rounded-xl bg-purple-100 flex flex-col items-center space-y-3 shadow-sm hover:shadow-lg transition-all duration-200 hover:scale-105 border-2 border-purple-600"
//           >
//             <div className="w-full aspect-w-16 aspect-h-9 rounded-lg overflow-hidden"> {/* Changed aspect-h-12 to aspect-h-9 for standard 16:9 */}
//               <iframe
//                 src={`https://www.youtube.com/embed/${video.id}`}
//                 title={video.title}
//                 frameBorder="0"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//                 className="w-full h-full"
//               ></iframe>
//             </div>
//             <p className="font-semibold text-purple-700 text-center text-lg">{video.title}</p>
//             <p className="text-sm text-gray-700 text-center">{video.description}</p>
//           </div>
//         ))}
//       </div>

      
//     </div>
//   );
// };

// export default DiscoveryZone;


import React, { useState, useEffect } from 'react';
import { ShareIcon, FilmIcon } from '@heroicons/react/24/outline'; import { useNavigate } from 'react-router-dom'; // Import useNavigate
import baseUrl from '../../config';

const DiscoveryZone = () => {

  const navigate = useNavigate(); 
  const [videos, setVideos] = useState([]);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [errorVideos, setErrorVideos] = useState(null);

  const exploreItems = [
    {
      title: 'Game Zone!',
      desc: 'Practice addition and subtraction.',
      emoji: '🎮',
      color: 'text-indigo-600',
      bg: 'bg-indigo-100',
      path: '/game' // Add a path for navigation
    },
    // {
    //   title: 'New Story: "The Brave Little Robot"',
    //   desc: 'A tale about courage and friendship.',
    //   emoji: '📚',
    //   color: 'text-orange-600',
    //   bg: 'bg-orange-100',
    //   path: '/story' // Example for another item
    // },
    // {
    //   title: 'Creative Corner: Draw a Fantasy Creature',
    //   desc: 'Unleash your imagination!',
    //   emoji: '🎨',
    //   color: 'text-emerald-600',
    //   bg: 'bg-emerald-100',
    //   path: '/creative' // Example for another item
    // },
  ];

   // --- Fetch Videos from MERN Backend API ---
  // This function fetches the current list of featured videos from the API.
  const fetchVideos = async () => {
    setLoadingVideos(true);
    setErrorVideos(null); // Clear previous errors

    try {
      const response = await fetch(baseUrl + 'api/get/feature/get'); // Adjust the URL as needed
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // Sort videos by creation date descending (most recent first) for display
      // This matches the order they appear on the admin side
      data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setVideos(data);
    } catch (error) {
      console.error("Error fetching videos for DiscoveryZone:", error);
      setErrorVideos(`Failed to load videos: ${error.message}. Please check backend.`);
    } finally {
      setLoadingVideos(false);
    }
  };

  // useEffect to fetch videos when the component mounts
  useEffect(() => {
    fetchVideos();
  }, []);

  const handleExploreItemClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border-b-4 border-pink-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01] overflow-hidden">
      <h2 className="text-2xl md:text-2xl font-extrabold text-gray-900 mb-3 flex items-center">
        <ShareIcon className="w-7 h-7 md:w-8 md:h-8 mr-2 text-pink-600" />
        Discovery Zone
      </h2>
      <p className="text-base text-gray-700 mb-3">New adventures await! Explore and learn something new.</p>

      {/* Explore More Section */}
      <h3 className="text-xl font-bold text-gray-800 mb-3">Explore More!</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
        {exploreItems.map((item, index) => (
          <div
            key={index}
            className={`p-3 rounded-xl ${item.bg} flex items-center space-x-3 shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] cursor-pointer`}
            onClick={() => handleExploreItemClick(item.path)} // Call handler on click
          >
            <div className={`flex-shrink-0 w-10 h-10 bg-white rounded-full flex items-center justify-center text-xl border-2 border-${item.color.split('-')[1]}-600`}>
              {item.emoji}
            </div>
            <div>
              <p className={`font-semibold text-base ${item.color}`}>{item.title}</p>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Featured Videos Section */}
      {/* <h3 className="text-xl font-bold text-gray-800 mb-3">Featured Videos: Fun & Learning!</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {videos.map((video) => (
          <div
            key={video.id}
            className="p-3 rounded-xl bg-purple-50 flex flex-col items-center space-y-3 shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] border border-purple-300 overflow-hidden"
          >
            <div className="w-full aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
              <iframe
                src={`https://www.youtube.com/embed/${video.id}`} // Corrected YouTube embed URL
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <p className="font-semibold text-purple-700 text-center text-base leading-tight mt-2">{video.title}</p>
            <p className="text-xs text-gray-600 text-center mb-1">{video.description}</p>
          </div>
        ))}
      </div> */}

        {/* Featured Videos Section */}
      <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
        <FilmIcon className="w-6 h-6 mr-2 text-gray-700" />
        Featured Videos: Fun & Learning!
      </h3>
      {loadingVideos ? (
        <p className="text-center text-gray-600 text-lg py-5">Loading featured videos...</p>
      ) : errorVideos ? (
        <p className="text-center text-red-500 text-lg py-5">{errorVideos}</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {videos.length === 0 ? (
            <p className="text-center text-gray-500 col-span-full text-base py-5">No featured videos available at the moment. Check back later!</p>
          ) : (
            videos.map((video) => (
              <div
                key={video._id} // Use MongoDB's _id as the unique key
                className="p-3 rounded-xl bg-purple-50 flex flex-col items-center space-y-3 shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] border border-purple-300 overflow-hidden"
              >
                <div className="w-full aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.youtubeId}`} // Use youtubeId from backend
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                </div>
                <p className="font-semibold text-purple-700 text-center text-base leading-tight mt-2">{video.title}</p>
                <p className="text-xs text-gray-600 text-center mb-1">{video.description}</p>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default DiscoveryZone;